<template>
  <div class="advantages">
    <swiper :options="swiperOption">
      <swiper-slide
        :id="'advantages-toast'+index"
        v-for="(item, index) in data.mini_slider"
        :key="index"
        class="d-flex flex-column justify-content-start align-items-start"
      >
        <div
          class="swiper-slide-img d-flex justify-content-center align-items-center mb-3">
          <img class="swiper-slide-img-item" :src="item.img.url" alt />
        </div>
        <p class="swiper-slide-description">{{item.title}}</p>
          <b-popover :target="'advantages-toast'+index" triggers="hover" placement="bottom">
            <template v-slot:title>{{item.title}}</template>
          <p class="toast-description">{{item.text}}</p>
        </b-popover>
      </swiper-slide>
      <div
        class="control-container d-flex justify-content-center align-items-center"
        slot="pagination"
      >
        <div class="swiper-pagination swiper-pagination-bullets"></div>
      </div>
    </swiper>
  </div>
</template>

<script>
const axios = require("axios");
export default {
  props: {
    typeOfContent: String
  },
  data() {
    return {
      data: {},
      swiperOption: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 30,
        loop: false,
        breakpoints: {
          768: {
            slidesPerView: "auto",
            slidesPerGroup: 1,
            spaceBetween: 18
          }
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet(index, className) {
            return `<span class="${className} swiper-pagination-bullet-custom"></span>`;
          }
        }
      }
    };
  },
  created() {
    axios
      .get(`${this.$root.routLink}/?ajax&act=${this.typeOfContent}`, {
        responseType: "json"
      })
      .then(({ data }) => {
        this.data = JSON.parse(data.addons);
        if (this.data.visible !== 1) {
          this.$emit("hideup");
        }
      });
  }
};
</script>

<style lang="scss" scoped>
.advantages {
  width: 100%;
  background-color: transparent;
  overflow: hidden;

  @media only screen and (max-width: $sm),
    only screen and (max-device-width: $sm) {
    margin-right: -15px;
  }
  @media only screen and (max-width: $sm),
    only screen and (max-device-width: $sm) {
    .swiper-slide {
      width: 80%;
    }
  }

  .ttl {
    font-weight: 500;
    font-size: 44px;
    line-height: 110.1%;
    color: $darkColor;
  }

  .swiper-container {
    overflow: visible;
    padding-bottom: 20px;
    .swiper-slide {
      height: 183px;
      max-width: 255px;
      background-color: #ffffff;
      border-radius: 6px;
      padding: 20px 26px;
      &-img {
        border-radius: 100%;
        height: 70px;
        width: 70px;
        &-item {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      &-description {
        font-weight: 700;
        font-size: 16px;
        line-height: 110.1%;
        color: $mainFontColor;
      }
    }
  }
}
</style>